
import React from "react";
import { Box, Typography } from "@mui/material";

const OrderAddressesBlock = ({ addresses }) => {
    if (!addresses) return null;

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    md: "repeat(3, minmax(0, 1fr))",
                },
                gap: { xs: 3, md: 4 },
            }}
        >
            <AddressColumn data={addresses.billing} />
            <AddressColumn data={addresses.billing} />
            <AddressColumn data={addresses.transport} />
        </Box>
    );
};

const AddressColumn = ({ data }) => {
    if (!data) return null;
    const { title, lines = [] } = data;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Typography
                sx={{
                    fontFamily: "'Roboto Condensed', sans-serif",
                    fontWeight: 700,
                    fontSize: 14,
                    color: "#111111",
                }}
            >
                {title}
            </Typography>

            <Typography
                sx={{
                    fontFamily: "'Roboto Condensed', sans-serif",
                    fontSize: 16,
                    lineHeight: 1.2,
                    whiteSpace: "pre-line",
                    color: "#000000",
                }}
            >
                {lines.join("\n")}
            </Typography>
        </Box>
    );
};

export default OrderAddressesBlock;
